import {
  SET_ESG_COMPLIANCE_ASSESSMENT_DETAILS,
  SET_ORIGINAL_ESG_COMPLIANCE_ASSESSMENT_DETAILS,
  SET_SELECTED_COMPLIANCE_ROW_DATA,
  SET_ESG_COMPLIANCE_STRUCTURED_REPORT_DATA,
  SET_ESG_COMPLIANCE_FILTERED_REPORT_DATA,
  SET_ESG_COMPLIANCE_STRUCTURED_AUDIT_REPORT_DATA,
  SET_ESG_COMPLIANCE_FILTERED_AUDIT_REPORT_DATA,
   UPDATE_CHECKED_ITEMS,
  UPDATE_MAIN_TOPIC_ID,
  UPDATE_SUB_SUB_SECTION_ID,
  UPDATE_FILTER_STATUS,
  UPDATE_CONTRIBUTOR_IDS,
  UPDATE_APPROVER_IDS,
  CLEAR_ALL_FILTERS,
  
  
} from "constants/esgCompliance/esgSComplianceConst";

const initial_state = {
  esgComlianceAssessmentDetail: {},
  originalEsgComlianceAssessmentDetail: {},
  selectedRowData: null,
  esgComplianceStructuredReportData: [],
  esgComplianceFilteredReportData: [],
  esgComplianceStructuredAuditReportData: [],
  esgComplianceFilteredAuditReportData: [],
   isFetchingFilteredReportData: false,
   isFilteringAuditReportData:false,
  //  checkedItems: {},
  // mainTopicId: {},
  // sub_SubSectionId: [],
  // statusName: [],
  // contributorIds: [],
  // approverIds: [],
  reportFilters: {
    checkedItems: {},
    mainTopicId: {},
    sub_SubSectionId: [],
    statusName: [],
    contributorIds: [],
    approverIds: [],
  },
  auditFilters: {
    checkedItems: {},
    mainTopicId: {},
    sub_SubSectionId: [],
    statusName: [],
    contributorIds: [],
    approverIds: [],
  }
};
// Helper function to update nested state
const updateFilterState = (state, fromReport, property, value) => {
  
  const filterType = fromReport ? 'reportFilters' : 'auditFilters';
  return {
    ...state,
    [filterType]: {
      ...state[filterType],
      [property]: value
    }
  };
};

export default function reducer(state = initial_state, action) {
  switch (action.type) {
    case "RESET_STATE":
      return (state = {
        ...state,
        ...initial_state,
      });
    case SET_ESG_COMPLIANCE_ASSESSMENT_DETAILS:
      return (state = {
        ...state,
        esgComlianceAssessmentDetail: action.payload,
      });

    case SET_ORIGINAL_ESG_COMPLIANCE_ASSESSMENT_DETAILS:
      return (state = {
        ...state,
        originalEsgComlianceAssessmentDetail: action.payload,
      });

    case SET_SELECTED_COMPLIANCE_ROW_DATA:
      return (state = {
        ...state,
        selectedRowData: action.payload,
      });

    case SET_ESG_COMPLIANCE_STRUCTURED_REPORT_DATA:
      return (state = {
        ...state,
        esgComplianceStructuredReportData: action.payload,
      });

      case 'SET_ESG_COMPLIANCE_FILTERED_REPORT_LOADING':
      return { ...state, isFetchingFilteredReportData: action.payload };
      case 'SET_ESG_COMPLIANCE_FILTERED_AUDIT_REPORT_LOADING':
      return { ...state, isFilteringAuditReportData: action.payload };
      
    case SET_ESG_COMPLIANCE_FILTERED_REPORT_DATA:
      return (state = {
        ...state,
        esgComplianceFilteredReportData: action.payload,
      });
    case SET_ESG_COMPLIANCE_STRUCTURED_AUDIT_REPORT_DATA:
      return (state = {
        ...state,
        esgComplianceStructuredAuditReportData: action.payload,
      });
    case SET_ESG_COMPLIANCE_FILTERED_AUDIT_REPORT_DATA:
      return (state = {
        ...state,
        esgComplianceFilteredAuditReportData: action.payload,
      });
    //    case UPDATE_CHECKED_ITEMS:
    //   return { ...state, checkedItems: action.payload };
    // case UPDATE_MAIN_TOPIC_ID:
    //   return { ...state, mainTopicId: action.payload };
    // case UPDATE_SUB_SUB_SECTION_ID:
    //   return { ...state, sub_SubSectionId: action.payload };
    // case UPDATE_FILTER_STATUS:
    //   return { ...state, statusName: action.payload };
    // case UPDATE_CONTRIBUTOR_IDS:
    //   return { ...state, contributorIds: action.payload };
    // case UPDATE_APPROVER_IDS:
    //   return { ...state, approverIds: action.payload };
      // case CLEAR_ALL_FILTERS:
      // return {
      //   ...state,
      //    esgComplianceFilteredReportData:[],
      //   checkedItems: {},
      //   mainTopicId: {},
      //   sub_SubSectionId: [],
      //   statusName: [],
      //   contributorIds: [],
      //   approverIds: [],
      // };
        case UPDATE_CHECKED_ITEMS:
      return updateFilterState(
        state, 
        action.payload.fromReport, 
        'checkedItems', 
        action.payload.payload
      );
      
    case UPDATE_MAIN_TOPIC_ID:
      return updateFilterState(
        state, 
        action.payload.fromReport, 
        'mainTopicId', 
        action.payload.payload
      );
      
    case UPDATE_SUB_SUB_SECTION_ID:
      return updateFilterState(
        state, 
        action.payload.fromReport, 
        'sub_SubSectionId', 
        action.payload.payload
      );
      
    case UPDATE_FILTER_STATUS:
      return updateFilterState(
        state, 
        action.payload.fromReport, 
        'statusName', 
        action.payload.payload
      );
      
    case UPDATE_CONTRIBUTOR_IDS:
      return updateFilterState(
        state, 
        action.payload.fromReport, 
        'contributorIds', 
        action.payload.payload
      );
      
    case UPDATE_APPROVER_IDS:
      return updateFilterState(
        state, 
        action.payload.fromReport, 
        'approverIds', 
        action.payload.payload
      );
      case CLEAR_ALL_FILTERS:
  if (action.payload === true) {
    return {
      ...state,
      reportFilters: {
        checkedItems: {},
        mainTopicId: {},
        sub_SubSectionId: [],
        statusName: [],
        contributorIds: [],
        approverIds: [],
      },
        esgComplianceFilteredReportData: [],
    };
  } else {
    return {
      ...state,
      auditFilters: {
        checkedItems: {},
        mainTopicId: {},
        sub_SubSectionId: [],
        statusName: [],
        contributorIds: [],
        approverIds: [],
      },
       esgComplianceFilteredAuditReportData: [],
    };
  }



    default:
      return state;
  }
}
